/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { handleSetKPI, handleSetSettings } from "../../../handlers/HomeRoomHandlers";
import KPIWidgetFrontPanel from "../../../widgets/KPI/KPIWidgetFrontPanel";
import KPIWidgetSettings from "../../../widgets/KPI/KPIWidgetSettings";
import KPIWidgetInfo from "../../../widgets/KPI/KPIWidgetInfo";
import { PanelsBoard, KPIBoard, } from "vr-react-components";
import { useSelector } from "react-redux";
import React from "react";

const LeftPanelDesktop = React.memo(({ width, height }) => {
    const data = useSelector((state) => state.homeroom.kpi);
    const canModify = useSelector((state) => state.private.device.canModify);

    return (
        <PanelsBoard
            title="KPI monitoring"
            panel
            width={width}
            height={height}
            textSizeDecimal={20}
            aframeClasses={canModify ? "collidable" : ""}
        >
            <KPIBoard
                tiles
                data={data}
                aframeClasses={canModify ? "collidable" : ""}
                setKPI={handleSetKPI}
                setSettings={handleSetSettings}
                inVRMode={false}
                FrontPanelWidget={KPIWidgetFrontPanel}
                SettingsWidget={KPIWidgetSettings}
                InfoWidget={KPIWidgetInfo}
            />
        </PanelsBoard>
    );
});

export default LeftPanelDesktop;